import { render, staticRenderFns } from "./seller.vue?vue&type=template&id=0edd1e1e&scoped=true"
import script from "./seller.vue?vue&type=script&lang=js"
export * from "./seller.vue?vue&type=script&lang=js"
import style0 from "./seller.vue?vue&type=style&index=0&id=0edd1e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edd1e1e",
  null
  
)

export default component.exports